import type { PageKeyType } from '@/constants/page.constants';
import { SEO_MAPPING } from '@/constants/page.constants';
import { cmsQueryKeys } from '@/services/cms/cmsQueryKeys';
import type { CMSPage } from '@/services/cms/getCMSPageContent/schemas';
import { getSEOContent } from '@/services/cms/getSEOContent';
import { skipToken, useQuery } from '@tanstack/react-query';
import { useLocation } from '@tanstack/react-router';
import { Head } from '@unhead/react';
interface CMSSeoProps {
  data?: Pick<
    CMSPage,
    'seo_page_title' | 'seo_description' | 'seo_keywords'
  > | null;
}

const CMSSeo = ({ data = {} }: CMSSeoProps) => {
  const pathname = useLocation({
    select: (location) => location.pathname as PageKeyType,
  });

  const seoMapping = SEO_MAPPING[pathname];
  // Note: We just care about seo_page_title or seo_description, not seo_keywords
  const shouldFetchSEO = !data || !data.seo_page_title || !data.seo_description;
  const { data: seoData } = useQuery({
    queryKey: cmsQueryKeys.getSEOContent(seoMapping),
    queryFn: shouldFetchSEO ? () => getSEOContent(seoMapping) : skipToken,
    staleTime: Infinity,
  });

  return (
    <Head>
      <title>
        {data?.seo_page_title?.trim() ?? seoData?.seo_page_title?.trim()}
      </title>
      <meta
        name="description"
        content={
          data?.seo_description?.trim() ?? seoData?.seo_description?.trim()
        }
      ></meta>
      <meta
        name="keywords"
        content={data?.seo_keywords?.trim() ?? seoData?.seo_keywords?.trim()}
      ></meta>
      {seoMapping?.isIndexed === false && (
        <meta name="robots" content="noindex, nofollow" />
      )}
    </Head>
  );
};

export { CMSSeo };
